export default __webpack_public_path__ + "static/media/Frame_194.ed603629.jpg";